export const PAGE_SIZE_OPTIONS = {
  default: [5, 10, 20, 50],
  long: [5, 10, 20, 50, 100],
};

export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_INFINITE_PAGE = 50;
